import React, { useState } from 'react';
import useCollapse from 'react-collapsed';
import styled from 'styled-components/macro';

import { Button, FiltersCircle } from './TopicFilters.styles';
import AnimatedCaret from 'components/base/AnimatedCaret';
import Box from 'components/elements/Box';
import Span from 'components/elements/span';
import { LayoutWrapper } from 'components/base/Menu/SearchableMenu';
import { SearchFieldContainer } from 'components/styled/SearchField/SearchField';

interface IMobileTopicFiltersContainerProps {
  filterCount: number;
  title: string;
  topic?: string;
}

const MobileFiltersBox = styled(Box)<any>`
  ${LayoutWrapper} {
    width: 100%;
  }

  ${SearchFieldContainer} {
    margin: ${({ theme }): string =>
      `${theme.spacing.small} ${theme.spacing.small}`} !important;
  }

  button {
    &:disabled {
      opacity: 0.2;
    }
  }
`;

const MobileTopicFiltersContainer: React.FC<
  IMobileTopicFiltersContainerProps
> = (props) => {
  const { filterCount, title, topic } = props;
  const [isOpen, setOpen] = useState(false);
  const transitionDuration = 100;
  const transitionStyles = { transitionDuration: `${transitionDuration}ms` };
  const { getCollapseProps, getToggleProps } = useCollapse({
    expandStyles: transitionStyles,
    collapseStyles: transitionStyles,
    isOpen,
  });

  const onClick = (): void => {
    setOpen(!isOpen);
  };

  return (
    <MobileFiltersBox
      backgroundColor="white"
      px="0"
      my="2"
      mx={topic === 'charts' ? 0 : 2}
      id="opus-topic-filter-bar"
      data-pw="filter-wrapper"
    >
      <Button
        {...getToggleProps({ onClick })}
        display="flex"
        align-items="center"
        justify-content="flex-start"
        width="100%"
        fontSize={16}
        isSmallScreen
        py={3}
      >
        {!!filterCount && <FiltersCircle />}

        <Span paddingLeft="1">{title}</Span>
        <Span marginLeft="auto">
          <AnimatedCaret aria-hidden isPointingUp={isOpen} />
        </Span>
      </Button>
      <Box {...getCollapseProps()}>{props.children}</Box>
    </MobileFiltersBox>
  );
};

export default MobileTopicFiltersContainer;
